import { render } from "./index.vue?vue&type=template&id=d1b8616a"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=d1b8616a&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/modules/md-snapshot-search/template4/components/board-card/index.vue'],['render',render],['__file',"index.vue"]])

export default __exports__